import { ReactNode, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Menu, Breadcrumb } from "antd";
import {
  LogoutOutlined,
  HomeOutlined,
  AppstoreOutlined,
  BarsOutlined,
  ReadOutlined,
  FolderOpenOutlined,
  InboxOutlined,
  BarChartOutlined,
  BlockOutlined,
  ApartmentOutlined,
  AlignCenterOutlined,
  SignatureOutlined,
  ApiOutlined,
  CloudDownloadOutlined,
  PrinterOutlined,
  ProductOutlined,
  PaperClipOutlined,
  GoldOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { useCustomOperate } from "@/hooks";
import _ from "lodash";
import CustomUserSearch from "./CustomUserSearch";
import CustomIpLocation from "./CustomIpLocation";

import Logo from "@/assets/logo.png";

const { Header, Content, Footer, Sider } = Layout;

type Props = {
  children: ReactNode;
}

export default function CustomLayout({ children }: Props) {
  // 菜单
  const menuData: any = [
    { label: "首页", key: '/', icon: <HomeOutlined /> },
    { label: "书籍管理", key: '/bookManagement', icon: <AppstoreOutlined /> },
    { label: "单词管理", key: '/wordManagement', icon: <BarsOutlined /> },
    { label: "分类管理", key: '/sortManagement', icon: <ReadOutlined /> },
    { label: "例句管理", key: '/exampleManagement', icon: <FolderOpenOutlined /> },
    { label: "笔记管理", key: '/noteManagement', icon: <InboxOutlined /> },
    { label: "助记管理", key: '/memoryManagement', icon: <SignatureOutlined /> },
    // { label: "下载管理", key: '/downloadManagement', icon: <CloudDownloadOutlined /> },
    { label: "打印管理", key: '/printManagement', icon: <PrinterOutlined /> },
    { label: "订单管理", key: '/orderManagement', icon: <BarChartOutlined /> },
    { label: "产品管理", key: '/productManagement', icon: <ProductOutlined /> },
    { label: "用户管理", key: '/userManagement', icon: <ApartmentOutlined /> },
    { label: "预购管理", key: '/preorderManagement', icon: <ApiOutlined /> },
    { label: "邀请记录", key: '/invitationRecord', icon: <PaperClipOutlined /> },
    { label: "佣金记录", key: '/commissionRecord', icon: <GoldOutlined /> },
    { label: "解析记录", key: '/analysisRecord', icon: <AlignCenterOutlined /> },
    { label: "文章管理", key: '/articleManagement', icon: <BookOutlined /> },
  ];
  // 当前路径
  const { pathname } = useLocation();
  // 展开、收起
  const [collapsed, setCollapsed] = useState(false);
  // 自定义操作
  const { customOpen, customLogout } = useCustomOperate();

  // 当前菜单
  const currentMenu = useMemo(() => _.find(menuData, { key: pathname }), [pathname]);

  return (
    <Layout className="min-h-screen">
      <Header className="p-3 bg-white flex justify-between items-center border-b-[0.5px] border-[#DBDBDB] border-solid">
        <img src={Logo} alt="" className="w-[175px] h-[40px] cursor-pointer" onClick={() => customOpen(`/`)} />
        <div className="flex items-center">
          <CustomIpLocation />
          <CustomUserSearch />
          <div onClick={customLogout} className="ml-4 text-[#1677FF] font-semibold flex items-center cursor-pointer">
            <LogoutOutlined className="text-[18px]" />
            <div className="ml-0.5">退出</div>
          </div>
        </div>
      </Header>
      <Layout>
        <Sider theme="light" collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
          <Menu selectedKeys={[pathname]} mode="inline" items={menuData} onClick={(menuInfo) => customOpen(menuInfo.key) }/>
        </Sider>
        <Layout>
          <Content className="mx-4">
            {currentMenu && <Breadcrumb items={[{ title: (<>{currentMenu?.icon} {currentMenu?.label}</>) }]} className="my-4" />}
            {children}
          </Content>
          {/*<Footer className="text-center">*/}
          {/*  Copyright ©2025 All Rights Reserved*/}
          {/*</Footer>*/}
        </Layout>
      </Layout>
    </Layout>
  );
}
